import asian from './asian.svg';
import diver from './diver.svg';
import doctor from './doctor.svg';
import farmer from './farmer.svg';
import firefighter from './firefighter.svg';
import florist from './florist.svg';
import hindu from './hindu.svg';
import hipster from './hipster.svg';
import jew from './jew.svg';
import man from './man.svg';
import mechanic from './mechanic.svg';
import musician from './musician.svg';
import ninja from './ninja.svg';
import photographer from './photographer.svg';
import pilot from './pilot.svg';
import policeman from './policeman.svg';
import policewoman from './policewoman.svg';
import priest from './priest.svg';
import surgeon from './surgeon.svg';
import telemarketer from './telemarketer.svg';
import woman from './woman.svg';

const avatars = [
  { name: 'asian', icon: asian },
  { name: 'diver', icon: diver },
  { name: 'doctor', icon: doctor },
  { name: 'farmer', icon: farmer },
  { name: 'firefighter', icon: firefighter },
  { name: 'florist', icon: florist },
  { name: 'hindu', icon: hindu },
  { name: 'hipster', icon: hipster },
  { name: 'jew', icon: jew },
  { name: 'man', icon: man },
  { name: 'mechanic', icon: mechanic },
  { name: 'musician', icon: musician },
  { name: 'ninja', icon: ninja },
  { name: 'photographer', icon: photographer },
  { name: 'pilot', icon: pilot },
  { name: 'policeman', icon: policeman },
  { name: 'policewoman', icon: policewoman },
  { name: 'priest', icon: priest },
  { name: 'surgeon', icon: surgeon },
  { name: 'telemarketer', icon: telemarketer },
  { name: 'woman', icon: woman },
];

export default avatars;
